import React, { useState, useEffect, useCallback } from "react";
import ChatNav from "../ChatNav";
import Chats from "../Chats";
import Contact from "../Contact";
import CallLogs from "../CallLogs";
import Header from "../Header";
import MessageChat from "../MessageChat";
import NoChat from "../NoChat";
import { Flex, ViewPointHeight } from "./style";
import DraggableComponent from "../ModalComponent/DraggableComponent/DraggableComponent";
import MyProfile from "../ModalComponent/MyProfileModal";
import { useNavigate } from "react-router-dom";
import ImageViewModal from "../ModalComponent/ImageView";
import AddNamesModal from "../ModalComponent/AddNames";
import UsernameModal from "../ModalComponent/UsernameModal";
import axios from "axios";
import { io, Socket } from "socket.io-client";

interface DataItem {
  image: string;
  userName: string;
  chatId: string;
  userId: string;
  conversationId: string;
}

const MainChatBoard = () => {
  const [selectedData, setSelectedData] = useState<DataItem | null>(null);
  const [activeComponent, setActiveComponent] = useState("chats");
  const [isAudioCallModal, setIsAudioCallModal] = useState(false);
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const navigate = useNavigate();
  const [name, setName] = useState(false);
  const [username, setUsername] = useState(false);

  const [sockets, setSockets] = useState<Socket<any, any> | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    if (!storedToken) {
      navigate("/login", { replace: true });
    }
  });

  const closeFunc = useCallback(() => {
    setName(false);
    setUsername(false);
  }, []);

  useEffect(() => {
    const newSocket = io("https://chatendpointv001-5825675edd1e.herokuapp.com");
    newSocket.on("connect", () => {
      console.log("Socket ID:", newSocket.id);
      setSockets(newSocket);
      console.log(sockets);
    });
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/getme`, {
        headers: Authorization,
      })
      .then((res: any) => {
        if (res.data.result.firstname === "") {
          setName(true);
        } else if (res.data.result.username === "") {
          setUsername(true);
        } else if (sockets) {
          sockets.emit("setUsername", res.data.result.username);
        }
      })
      .catch((err) => {});
  }, [Authorization, closeFunc, sockets]);

  useEffect(() => {
    if (sockets) {
      // Listen for the test notification event from the server
      sockets.on("sendNotification", (message: string) => {
        // Display browser notification
        new Notification("Test Notification", { body: message });
      });
    }
  }, [sockets]);

  // useEffect(() => {
  //   if (sockets) {
  //     sockets.on(
  //       "notification",
  //       ({
  //         message,
  //         conversationId,
  //       }: {
  //         message: any;
  //         conversationId: any;
  //       }) => {
  //         new Notification(message);
  //       }
  //     );
  //   }
  // }, [sockets]);

  useEffect(() => {
    if (sockets) {
      sockets.on(
        "notification",
        ({
          message,
          conversationId,
        }: {
          message: any;
          conversationId: any;
        }) => {
          // Display browser notification
          if (Notification.permission === "granted") {
            new Notification(message);
          } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then((permission) => {
              if (permission === "granted") {
                new Notification(message);
              }
            });
          }
        }
      );
    }
  }, [sockets]);

  const handleSelect = (data: DataItem) => {
    console.log("handleSelect called");
    setSelectedData(data);
    setActiveComponent("chats");
  };

  const handleSelected = (data: DataItem) => {
    console.log("handleSelected called");
    setSelectedData(data);
    setActiveComponent("chats");
  };

  const handleCloseChat = () => {
    setSelectedData(null);
  };
  const handleAudioCallModal = () => {
    setIsAudioCallModal(true);
  };
  const handleEndAudioCallModal = () => {
    setIsAudioCallModal(false);
  };

  const handleChatsClick = () => {
    setActiveComponent("chats");
  };

  const handleContactsClick = () => {
    setActiveComponent("contacts");
    handleCloseChat();
  };

  const handleCallLogsClick = () => {
    setActiveComponent("callLogs");
    handleCloseChat();
  };

  const handleMyProfileClick = () => {
    setActiveComponent("myProfile");
  };

  const handleCloseMyProfile = () => {
    setActiveComponent("chats");
  };

  return (
    <>
      <ViewPointHeight>
        {name && (
          <>
            <AddNamesModal closeFunc={closeFunc} />
          </>
        )}

        {username && (
          <>
            <UsernameModal closeFunc={closeFunc} />
          </>
        )}
        {isAudioCallModal && (
          <DraggableComponent handleEndCall={handleEndAudioCallModal} />
        )}
        <Header
          activeComponent={activeComponent}
          onViewProfileClick={handleMyProfileClick}
        />
        <Flex>
          <ChatNav
            onChatClick={handleChatsClick}
            onContactsClick={handleContactsClick}
            onCallLogsClick={handleCallLogsClick}
            onMyProfileClick={handleMyProfileClick}
          />
          {activeComponent === "chats" && (
            <Chats onSelect={handleSelect} conversationId={""} />
          )}
          {activeComponent === "contacts" && (
            <Contact onSelect={handleSelected} />
          )}
          {activeComponent === "callLogs" && <CallLogs />}
          {activeComponent === "myProfile" && (
            <MyProfile onCloseClick={handleCloseMyProfile} />
          )}
          {selectedData ? (
            <MessageChat
              data={selectedData}
              closeChat={handleCloseChat}
              audioCallModal={handleAudioCallModal}
            />
          ) : (
            <NoChat />
          )}
        </Flex>
      </ViewPointHeight>
    </>
  );
};

export default MainChatBoard;
